export default Object.freeze({
  PUBLIC: "public", // allow all users
  GUEST: "guest", // allow only guest users i.e. auth users are redirected
  STUDENT: "student", // allow only student users i.e. guest users and users of other roles are redirected
  SCHOOL: "school", // allow only school users i.e. guest users and users of other roles are redirected
  AGENT: "agent", // allow only agent users i.e. guest users and users of other roles are redirected
});
